import React from 'react';
import PropTypes from 'prop-types';
import VenueCard from '../VenueCard';

import './VenueListSkeleton.scss';
import { getTranslation } from '../../providers/TranslationProvider';

const skeletonProps = {
  $rootScope: {
    $broadcast: () => {},
  },
  loadNotifyModal: () => {},
  selectedDate: '',
  selectedSeats: 2,
  urlSlug: '',
  venueId: 12345,
};

const VenueListSkeleton = () => (
  <div className="VenueList VenueListSkeleton container" aria-label={getTranslation({ translationKey: 'communication_loading_message', fallback: 'Loading...' })}>
    <div className="CollectionHeadline skeleton">
        &nbsp;
    </div>
    <div className="VenueList__body">
      <div className="VenueCardGrid">
        <VenueCard {...skeletonProps} />
        <VenueCard {...skeletonProps} />
        <VenueCard {...skeletonProps} />
        <VenueCard {...skeletonProps} />
        <VenueCard {...skeletonProps} />
      </div>
    </div>
  </div>
);

VenueListSkeleton.propTypes = {
  displayName: PropTypes.string,
};

VenueListSkeleton.defaultProps = {
  displayName: 'VenueListSkeleton',
};

VenueListSkeleton.displayName = 'VenueListSkeleton';
export default VenueListSkeleton;
